import {
    DownOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
  } from "@ant-design/icons";
  import { LogoutOutlined } from "@ant-design/icons";
  import { Button, Dropdown, Menu } from "antd";
  import React from "react";
  import { Link, useNavigate } from "react-router-dom";
  import { DeleteToken } from "../../utils";
  import IMAGES from "../../const/Image";

const TopBar = ({ collapsed, setCollapsed }) => {
    const navigate = useNavigate();
    const handleLogout = () => {
        DeleteToken();
        navigate("/login", { replace: true });
    }
    return (
        <div className='flex justify-content-between align-items-center'>
            <div>{React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                className: 'trigger',
                onClick: () => setCollapsed(!collapsed),
            })}</div>
            {/* <div className='mr-20'>
                <span className='logout-btn' onClick={() => handleLogout()}>Logout<LogoutOutlined /></span>
            </div> */}
            <div className="mr-20 topheadericon2">
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="1">
                {" "}
                <span
                  className="cursor-pointer "
                  // onClick={() => hendleToViewUser(item)}
                >
                  <span className="logout-btn2">
                    <Link to={"/profile"}>Profile</Link>
                  </span>
                </span>
              </Menu.Item>
              <Menu.Item key="2">
                {" "}
                <span
                  className="cursor-pointer "
                  // onClick={() => hendleToViewUser(item)}
                >
                  <span className="logout-btn2" onClick={() => handleLogout()}>
                    Logout
                    <LogoutOutlined />
                  </span>
                  {/* <SvgIcon.Visibility className="scale-icon edit-icon" /> */}
                  {/* View */}
                </span>
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
        >
          <button
            className="profilebtntopbar  ml-3  "
            // onClick={() => hendleToViewLicence(item)}
          >
            <img
              src={IMAGES.LogoShort}
              className="cursor-pointer"
              alt=""
              style={{
                width: "45px",
                borderRadius: "50%",
                marginRight: "10px",
              }}
              onClick={() => navigate("/")}
            />
            Profile <DownOutlined />
          </button>
        </Dropdown>
      </div>
        </div >
    )
}

export default TopBar